import { IPrepaidroomcluster } from '@core/models/PrepaidRoomCluster/IPrepaidRoomCluster';
import { IHotelAvailability } from '@core/models/HotelAvailability/IHotelAvailability';
import { createAction, props } from '@ngrx/store';
import { RoomFilter } from '@core/models/room-filter/room-filter';
import { DisneyRoomCluster } from '@core/models/disney-room-cluster/DisneyRoomCluster.model';

export enum HotelAvailabilityActions {
  SET_HOTEL_AVAILABILITY = '[Hotel] setHotelAvailability',
  SET_ALL_REFUNDABLE_ROOMS = '[Hotel] setAllRefundableRoomCluster',
  GENERATE_DISNEY_CLUSTER = '[Hotel] GENERATE_DISNEY_CLUSTER',
  SET_DISNEY_CLUSTER = '[Hotel] SET_DISNEY_CLUSTER',
  SET_DISNEY_CLUSTER_LEGACY = '[Hotel] SET_DISNEY_CLUSTER_LEGACY',
  SET_ROOMS_FILTERS = '[Hotel] SET_ROOMS_FILTERS',
  SET_EMPTY_ROOMS_FILTERS = '[Hotel] SET_EMPTY_ROOMS_FILTERS',
  SET_FILTERED_ROOMS = '[Hotel] SET_FILTERED_ROOMS',
  CHANGE_FILTER = '[Hotel] CHANGE_FILTER',
  RESET_FILTERS = '[Hotel] RESET_FILTERS',
  UNSET_FILTERS = '[Hotel] UNSET_FILTERS',
  SHOW_MORE_ROOMS = '[Hotel] SHOW_MORE_ROOMS',
  RESET_PAGINATION = '[Hotel] RESET_PAGINATION',
  SET_PAGE_SIZE = '[Hotel] SET_PAGE_SIZE',
  RESET_HOTEL_AVAILABILITY = '[Hotel] RESET_HOTEL_AVAILABILITY',
}

export const setHotelAvailability = createAction(
  HotelAvailabilityActions.SET_HOTEL_AVAILABILITY,
  props<{ hotelAvailability: IHotelAvailability }>(),
);
export const setAllRefundableRoomCluster = createAction(
  HotelAvailabilityActions.SET_ALL_REFUNDABLE_ROOMS,
  props<{ allRefundableRoomCluster: IPrepaidroomcluster[] }>(),
);
export const setRoomsFilters = createAction(
  HotelAvailabilityActions.SET_ROOMS_FILTERS,
  props<{ filters: RoomFilter[] }>(),
);
export const setEmptyRoomsFilters = createAction(
  HotelAvailabilityActions.SET_EMPTY_ROOMS_FILTERS,
);
export const changeRoomFilter = createAction(
  HotelAvailabilityActions.CHANGE_FILTER,
  props<{ filter: RoomFilter }>(),
);
export const setFilteredRooms = createAction(
  HotelAvailabilityActions.SET_FILTERED_ROOMS,
  props<{ rooms: any[] }>(),
);

export const showMoreRooms = createAction(HotelAvailabilityActions.SHOW_MORE_ROOMS);

export const resetFilters = createAction(HotelAvailabilityActions.RESET_FILTERS);

export const unsetFilters = createAction(HotelAvailabilityActions.UNSET_FILTERS);

export const setPageSize = createAction(
  HotelAvailabilityActions.SET_PAGE_SIZE,
  props<{ pageSize: number }>(),
);

export const resetPagination = createAction(HotelAvailabilityActions.RESET_PAGINATION);

export const generateDisneyCluster = createAction(
  HotelAvailabilityActions.GENERATE_DISNEY_CLUSTER,
);

export const setDisneyCluster = createAction(
  HotelAvailabilityActions.SET_DISNEY_CLUSTER,
  props<{ clusters: DisneyRoomCluster[] }>(),
);

export const setDisneyClusterLegacy = createAction(
  HotelAvailabilityActions.SET_DISNEY_CLUSTER_LEGACY,
  props<{ clusters: any[] }>(),
);

export const resetHotelAvailability = createAction(
  HotelAvailabilityActions.RESET_HOTEL_AVAILABILITY,
);
